require('../scss/style.scss');

require('browsernizr/test/css/rgba');
require('browsernizr/test/file/filesystem');
require('browsernizr/test/websockets');

var svg4everybody = require('svg4everybody/dist/svg4everybody');

// Require our modules
var Hero = require('./widgets/hero');
var Navigation = require('./navigation');
var Articles = require('./articles');
var ArticleSingle = require('./article_single');
var Portfolio = require('./Portfolio');
var Menu = require('./menu');

// Modernizr
var Modernizr = require('browsernizr');

// Set global variables
window.WINDOW_WIDTH = $(window).width();
window.WINDOW_HEIGHT = $(window).height();
window.BREAK_XL = 1200;
window.BREAK_LG = 992;
window.BREAK_MD = 768;
window.BREAK_SM = 576;
window.BREAK_XS = 480;

$(document).ready(function() {

	// Lets get the SVGs in:

	svg4everybody();

	// Initialise Navigation
	var navigation = new Navigation($(document));

	// Initialise Portfolio
	var portfolio = new Portfolio($(document));

	// Initialise Menu
	var menu = new Menu($(document));

	// Only initialise the class if the widget exists on the page.

	var hero;

	// Initialise Articles
	self.articles = new Articles($(document));

	var aritcle_single = new ArticleSingle($(document));

	$('body').find('.widget').each(function(index){

		if($(this).hasClass('widget_hero')) {

			hero = new Hero($(this));

		}

	})

});